import { createContext } from 'react';

export default createContext({
  addToForm: null,
  isValid: null,
  onFormChange: null,
  removeFromForm: null,
  resetta: null,
  stato: null,
  validare: null,
});
